import type { Infer } from 'superstruct';
import { assign, object, optional, partial } from 'superstruct';

import { AddRoleDto } from './add-role.dto';
import { ApplyEditsToUsersOptionsDto } from './apply-edits-to-users-options.dto';

export const EditRoleDto = assign(
	partial(AddRoleDto),
	object({
		applyEditsToUsers: optional(ApplyEditsToUsersOptionsDto),
	})
);

export type EditRoleDto = Infer<typeof EditRoleDto>;
